<script setup>
import Buttons from '@/components/ui/Buttons.vue';
import InfoStatCard from '@/components/cards/InfoStatCard.vue';
import MarkCard from '@/components/cards/MarkCard.vue';

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data?.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div
        class="info-stat"
        :class="[data?.background_color === 'black' ? 'white' : 'black']"
      >
        <div class="info-stat__top max-w-784">
          <div class="info-stat__content">
            <h2
              v-if="data.title"
              class="mb-0 info-stat__title h2 text-center"
              data-aos="fade-up"
              data-aos-easing="ease-out-cubic"
              v-html="data.title"
            ></h2>
            <div
              v-if="data.text"
              class="mb-0 info-stat__text body-1-regular text-center"
              data-aos="fade-up"
              data-aos-easing="ease-out-cubic"
              v-html="data.text"
            ></div>
          </div>
        </div>
        <div
          ref="wrap"
          :class="[`info-stat__items info-stat__items--${data?.columns_count}`]"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
        >
          <InfoStatCard
            v-for="(item, index) in data.items"
            :key="index"
            :title="item?.title"
            :value="item?.value"
            :background-color="data?.background_color"
            :view="data?.template"
            data-aos="fade-up"
            :data-aos-delay="index >= 1 ? 100 + 100 * index : 100"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.info-stat {
  $parent: &;
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__top {
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin: 0 auto;
    @include media-breakpoint-up(sm) {
      gap: 64px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 64);
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    gap: 32px;
    @include media-breakpoint-up(sm) {
      gap: 48px;
      margin: 0 auto;
    }

    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 48);
    }
  }
  &__title {
    margin: 0 auto;
    @include media-breakpoint-up(sm) {
      max-width: 80.5%;
    }
    @include media-breakpoint-up(md) {
      max-width: unset;
    }
  }
  &__text {
    margin: 0 auto;
    &:deep(p:last-child) {
      margin-bottom: 0;
    }
    @include media-breakpoint-up(sm) {
      margin: 0 auto;
      max-width: 80.5%;
    }
    @include media-breakpoint-up(md) {
      max-width: 74.5%;
    }
  }
  &__items {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    &--centered {
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-up(sm) {
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-up(md) {
      &--3 {
        grid-template-columns: repeat(3, 1fr);
      }
      &--4 {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
  }
}
</style>
